<template>
	<div class="o-loader"></div>
</template>
<script>
export default {
	name:'loader'
}
</script>